"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _configuratorModelSelector = _interopRequireDefault(require("../styles/configurator-model-selector.css"));
var _modelOptions = _interopRequireDefault(require("./model-options"));
var _modelHeader = _interopRequireDefault(require("./model-header"));
var _configuratorModelSelector2 = require("./configurator-model-selector.props/configurator-model-selector.propTypes");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var _DataUtils = new _mmcDataUtilities["default"](),
  handleNestedProp = _DataUtils.handleNestedProp;
var ConfiguratorModelSelector = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(ConfiguratorModelSelector, _React$Component);
  ConfiguratorModelSelector.resourceType = function resourceType() {
    return 'ModelSelector_1_0_0';
  };
  ConfiguratorModelSelector.isMobile = function isMobile() {
    var desktopWidth = 768;
    return typeof window !== 'undefined' && window.innerWidth < desktopWidth;
  };
  ConfiguratorModelSelector.changeEventWithScroll = function changeEventWithScroll(passThrough) {
    if (typeof window !== 'undefined' && this.isMobile()) {
      if (window.scrollTo !== undefined) {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      } else {
        document.body.scrollTop = 0; // eslint-disable-line
      }
    }
    return passThrough;
  };
  function ConfiguratorModelSelector(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    var changeEvent = props.changeEvent || _this.updateSelectedCard.bind((0, _assertThisInitialized2["default"])(_this));
    _this.state = {
      isSelected: null,
      changeEvent: changeEvent
    };
    _this.updateSelectedCard = _this.updateSelectedCard.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  var _proto = ConfiguratorModelSelector.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var data = this.props.data;
    var market = data.market,
      vehicleInfo = data.vehicleInfo;
    if ((market.toLowerCase() === 'es' || market.toLowerCase() === 'pt' || market.toLowerCase() === 'fi') && typeof window !== 'undefined' && window.dataLayer) {
      var _data$progressBar, _data$progressBar$ite;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'car_configuration_view',
        comp_product: {
          vehicle_type: 'car',
          brand: 'mitsubishi',
          product_condition: 'new',
          model: vehicleInfo != null && vehicleInfo.name ? vehicleInfo == null ? void 0 : vehicleInfo.name.toLowerCase() : "",
          version: null,
          color: null,
          upholstery: null,
          accesories: null,
          fuel_type: null,
          price: null,
          currency: null,
          step: "1/" + (data == null ? void 0 : (_data$progressBar = data.progressBar) == null ? void 0 : (_data$progressBar$ite = _data$progressBar.items) == null ? void 0 : _data$progressBar$ite.length)
        }
      });
    }
  };
  _proto.updateSelectedCard = function updateSelectedCard(e) {
    var fieldValue = e.target.value || null;
    this.setState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        isSelected: fieldValue
      });
    });
  };
  _proto.render = function render() {
    var _this$props = this.props,
      data = _this$props.data,
      theme = _this$props.theme,
      market = _this$props.market,
      selectedModel = _this$props.selectedModel,
      isTrimLineInsteadOfModelCode = _this$props.isTrimLineInsteadOfModelCode;
    var _this$state = this.state,
      isSelected = _this$state.isSelected,
      changeEvent = _this$state.changeEvent;
    var selectedCard = selectedModel || isSelected;
    return /*#__PURE__*/_react["default"].createElement("fieldset", {
      className: theme['col-xs-12'] + " " + _configuratorModelSelector["default"].fieldContainer
    }, /*#__PURE__*/_react["default"].createElement(_modelHeader["default"], {
      theme: theme,
      headingText: handleNestedProp(data, 'data.headingText'),
      disclaimerData: data.disclaimerData
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.row + " " + _configuratorModelSelector["default"].optionsListView
    }, /*#__PURE__*/_react["default"].createElement(_modelOptions["default"], {
      msrpLabel: handleNestedProp(data, 'data.msrpLabel'),
      models: handleNestedProp(data, 'data.models'),
      theme: theme,
      market: market,
      updateSelectedCard: ConfiguratorModelSelector.changeEventWithScroll(changeEvent),
      selectedCard: selectedCard,
      addPriceDisclaimer: data.addPriceDisclaimer,
      priceDisclaimerId: data.priceDisclaimerId,
      disclaimerData: data.disclaimerData,
      isTrimLineInsteadOfModelCode: isTrimLineInsteadOfModelCode
    })));
  };
  return ConfiguratorModelSelector;
}(_react["default"].Component);
exports["default"] = ConfiguratorModelSelector;
ConfiguratorModelSelector.displayName = 'ConfiguratorModelSelector';